<template>
    <div>
        <div :class="{'dropdown-content': !inline, 'dropdown-content-padded': !inline}">
            <r-input
                ref="input"
                :auto-resize="true"
                rows="1"
                label="Enter values"
                :auto-focus="autoFocus"
                :value="value"
                @input="updateValue"
                @key-submit="updateFilter"
                :multiline="true"
                :submit-on-enter="true"
                help-text="Enter one or more values separated by comma or new line. Shift + Enter adds a new line."
            />
        </div>
        <slot v-if="$slots.footer" name="footer"/>
        <filter-footer v-else @update="updateFilter"/>
    </div>
</template>

<script>
    import filterMixins from './filter-mixins';
    import FilterFooter from './filter-footer';

    export default {
        mixins: [filterMixins],
        components: {FilterFooter},
        data() {
            return {
                value: '',
            };
        },
        created() {
            const values = this.adapter.getInitialFilterValue(this.filter);
            this.value = values ? values.join(', ') : '';
        },
        methods: {
            makePayload() {
                return this.adapter.getFilterPayload({
                    index: this.index,
                    filter: this.filter,
                    assign: {values: this.getUniqueValues()},
                });
            },
            updateValue(value) {
                this.value = value;
                if (this.inline) {
                    this.$nextTick(() => {
                        const payload = this.makePayload();
                        this.$emit('input', payload);
                    });
                }
            },
            updateFilter() {
                const payload = this.makePayload();
                this.$emit('update', payload);
                this.$parent.$emit('request-popper-hide');
            },
            getUniqueValues() {
                let values = this.value.trim();
                if (values !== '') {
                    values = values
                        .split(/[\r\n,]+/gm) // split on newlines or commas
                        .reduce((result, value) => {
                            const clean = value.trim();
                            if (clean !== '') {
                                result.push(clean);
                            }
                            return result;
                        }, []);
                    const unique = new Set(values);
                    return [...unique];
                }
                return [];
            },
            focusFilter() {
                this.$el.querySelector('input').focus();
            },
        },
    };
</script>
